const debounce = (func, wait = 99) => {
    let timeout = 0;
    let timestamp = 0;
    let ts;
    let ars;
    const run = () => {
        timeout = 0;
        func.apply(ts, ars);
    };
    const later = () => {
        const last = performance.now() - timestamp;
        if (last < wait) {
            timeout = window.setTimeout(later, wait - last);
        }
        else {
            run();
        }
    };
    return function (...args) {
        ts = this;
        ars = args;
        timestamp = performance.now();
        if (timeout === 0) {
            timeout = window.setTimeout(later, wait);
        }
    };
};
export { debounce };
